import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef, useImperativeHandle, useState } from "react";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";
import { t } from "i18next";
import { Trans } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const VerifyConfirmDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <IconButton
        sx={{ position: "absolute", top: "5px", right: "5px" }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle
        variant="h1"
        fontWeight={700}
        fontSize={"1.5rem"}
        fontFamily={"inter"}
        sx={{ m: 0, p: 2, textAlign: "center" }}
        id="customized-dialog-title"
      >
        {t("successfullyChanged")}
      </DialogTitle>
      <DialogContent>
        {paramsData?.type === "save_new_client" && (
          <Typography variant="body1" textAlign={"center"}>
            {t("appointmentDoneMessage")}
          </Typography>
        )}
        <Typography variant="body1" textAlign={"center"}>
          <Trans
            i18nKey="loginAgainMessage"
            style={{ color: appcolors.slateGrey }}
            color={appcolors.slateGrey}
          >
            Now you can login again with new password If you feel issue feel
            free to <b style={{ color: "black" }}>contact us</b>{" "}
          </Trans>
        </Typography>
        <Box my={3} textAlign={"center"}>
          <img src={allIcons.conformIcon} alt={"confirm-icon"} width={40} />
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
});

export default VerifyConfirmDialog;
